import {
  FILTER_CATALOGS,
  FILTER_COLOR,
  FILTER_DIMENSIONS,
  FILTER_SEGMENT,
  FILTER_SILHOUETTE,
  FILTER_SIZE,
  FILTER_SPORT
} from './constants';

export const getShopProducts = state => state.shop.products.styles;
export const getProductsRequest = state => state.shop.productRequestData;
export const getProductCount = state => state.shop.products.count;
export const getProductsDept = state => state.shop.products.dept;
export const getSelectedProduct = state => state.shop.selectedProduct;
export const getCursorValue = state => state.shop.after;
export const getIsFetching = state => state.shop.isFetching;
export const getProductAvailability = state => state.shop.productAvailability;
export const getProductFutureAvailability = state => state.shop.productFutureAvailability;
export const getProductMinRules = state => state.shop.productMinRules;
export const getProductMaxRules = state => state.shop.productMaxRules;
export const getSelectedDepartment = state => state.shop.selectedDepartment;
export const getSelectedFacets = state => state.shop.facets.selected;
export const getSelectedFilters = state => state.shop.selectedFilters;
export const priceRange = state => state.shop.priceRange;
export const priceRangeMax = state => state.shop.priceRange.wholesaleMax;
export const priceRangeMin = state => state.shop.priceRange.wholesaleMin;
export const priceRangeSet = state => state.shop.priceRangeSet;
export const searchTerm = state => state.shop.searchTerm;
export const isAdminCart = state => state.shop.isAdminCart;
export const adminCartId = state => state.shop.adminCartId;
export const isShopping = state => state.shop.isShopping;
export const selectAllSizesAvailable = state => state.shop.allSizesAvailable;
export const selectIncludeUnavailableProduct = state => state.shop.includeUnavailableProduct;
export const getIsFetchingStyleDetails = state => state.shop.isFetchingStyleDetails;

const alwaysOnFacets = ['gender', 'division'];
export const getFacets = state => {
  const { facets } = state.shop.facets;

  return facets.filter(facet => alwaysOnFacets.includes(facet.key));
};

export const getActiveSubTypeFacets = state => state.shop.activeSubTypes;
export const getAllSubTypeFacets = state => state.shop.allSubTypes;

const filters = [
  FILTER_CATALOGS,
  FILTER_COLOR,
  FILTER_DIMENSIONS,
  FILTER_SEGMENT,
  FILTER_SILHOUETTE,
  FILTER_SIZE,
  FILTER_SPORT
];
export const getFilters = state => {
  const { facets } = state.shop.facets;

  return facets.filter(facet => filters.includes(facet.key));
};

export const filterCount = state => {
  const filterListLength = Object.keys(state.shop.selectedFilters).length;
  const priceIsSet = state.shop.priceRangeSet;

  if (!filterListLength || filterListLength === 0) {
    return priceIsSet ? 1 : null;
  }

  let filterLength = 0;
  if (priceIsSet) {
    filterLength = 1;
  }
  filterLength += filterListLength;

  return filterLength;
};

export const getShopProduct = (state, productCode) => {
  const styleNumber = productCode.split('-')[0];

  if (styleNumber) {
    const style = getShopProducts(state).find(style => style.styleNumber === styleNumber);
    return style && style.products.find(product => product.productCode === productCode);
  }

  return undefined;
};

export const getProductDetailsFromId = (state, productCode) => {
  return state.shop.selectedStyleDetails[productCode];
};

export const getProductMaxAmountOrderable = (state, productCode) => {
  return getProductDetailsFromId(state, productCode)?.maxAmountOrderable;
};
